<template>
  <img
    data-cy="c-character"
    :class="['c-character', { '-modal' : this.modal }]"
    :src="image"
    :alt="description"
    :title="description"
    :style="{ 'background-image': `url(${image})` }"
  />
</template>

<script>
const isType = (value) => {
  const types = [ 'sad', 'embarrassed', 'happy', 'greedy', 'disappointed', 'searching' ]
  const isValid = types.includes(value)
  return isValid
}

export default {
  props: {
    description: String,
    type: {
      type: String,
      validator: isType
    },
    modal: {
      type: Boolean
    }
  },
  data () {
    return {
      image: ''
    }
  },
  watch: {
    type () {
      this.loadImage()
    }
  },
  methods: {
    async loadImage () {
      this.image = await import(`@assets/img/character-${this.type}.svg`)
    }
  },
  mounted () {
    this.loadImage()
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

$c-character-size: 130px;
$c-character-modal-size: 100px;

.c-character {
  @include size($c-character-size);
  box-sizing: border-box;
  display: block;
  padding: calc($c-character-size / 2);
  background: {
    size: contain;
    repeat: no-repeat;
    position: center;
  }

  &.-modal {
    @include size($c-character-modal-size);
    padding: calc($c-character-modal-size / 2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CCharacter.vue